// В.2.b: Парамедик (liv_paramedik, common, 2/1/4).
// Двойная Аура (диздок 7.4):
//   - 1-я линия: 1 урон случайному вражескому персонажу.
//     Срабатывает ТОЛЬКО в раунде 1 хил-прохода Ф3, в раунде 2 пропуск.
//     Цели: все живые вражеские юниты + вражеский Герой ТОЛЬКО если у врага
//     нет юнитов (Авангард Героя снят).
//   - 2-я линия: +1 ХП случайному союзному персонажу (юниты + союзный Герой;
//     Парамедик может попасть на самого себя).
//     Срабатывает в ОБОИХ раундах.
//     Если выбранная цель уже на полном ХП (current.hp === max_hp) →
//     applyTemporaryBuff +0/1/0 до конца хода (overshield: +1 max_armor +
//     синхронный +1 current_armor; expiresAtTurn = currentTurn + 1).
//     Если цель не на полном ХП — обычный healUnit +1 ХП (overshield не выдаётся).
//
// Молчание блокирует Ауру — это уже в каркасе runLivLifeHealAuras.

import { registerLivLifeHealAura } from './heal-auras.js';
import { registerImplementedAbility } from './warn-unimplemented.js';
import { healUnit } from './heal.js';
import { applyDamage } from '../../combat.js';
import { applyTemporaryBuff } from '../../buffs.js';
import { onUnitDamaged, onHeroDamaged } from '../deus/index.js';
import { dispatchUnitDied } from '../deus/hooks.js';
import { shortHeroName } from '../../../data/heroes.js';

export const CARD_ID = 'liv_paramedik';
const LABEL = 'Парамедик';

registerImplementedAbility(CARD_ID, 'passive');

registerLivLifeHealAura(CARD_ID, (state, card, round) => {
  const ownerIdx = card.ownerId;
  if (ownerIdx == null) return;
  const line = card.line;
  if (line == null) return;
  if (line === 0) {
    // 1-я линия: 1 урон случайному врагу. Только в раунде 1.
    if (round !== 1) return;
    paramedikLine0Attack(state, ownerIdx, card);
    return;
  }
  if (line === 1) {
    // 2-я линия: +1 ХП случайному союзнику (или overshield, если на полном ХП).
    paramedikLine1Heal(state, ownerIdx, card);
    return;
  }
});

function paramedikLine0Attack(state, ownerIdx, paramedik) {
  const enemy = state.players[1 - ownerIdx];
  if (!enemy) return;
  // Цели: все живые вражеские юниты.
  const enemyUnits = enemy.unitsOnField().filter(u => u.isAlive());
  let target = null;
  if (enemyUnits.length > 0) {
    target = enemyUnits[state.rng.int(enemyUnits.length)];
  } else if (enemy.hero?.hp > 0) {
    // Юнитов нет — стреляем в Героя (Авангард снят).
    target = enemy.hero;
  } else {
    return;
  }
  // Иммунитет Героя — урон 0, лог.
  if (target.type === 'hero' &&
      enemy.heroImmuneUntilTurn != null &&
      state.currentTurn <= enemy.heroImmuneUntilTurn) {
    state.log?.add(
      `🛡 ${shortHeroName(target)} [${enemy.name}]: Иммунитет — выстрел Парамедика блокирован`
    );
    return;
  }
  const before = { hp: target.current?.hp ?? target.hp, armor: target.current?.armor ?? target.armor };
  const r = applyDamage(target, 1);
  const targetName = target.type === 'hero' ? shortHeroName(target) : target.name_ru;
  state.log?.add(
    `🩸 ${LABEL} [${state.players[ownerIdx]?.name}] → ${targetName} [${enemy.name}]: ` +
    `1 урон (HP ${before.hp}→${target.hp}, броня ${before.armor}→${target.armor})`
  );
  // Триггеры на урон.
  const taken = (r.armorAbsorbed || 0) + (r.hpLost || 0);
  if (target.type === 'hero') {
    if (taken > 0) onHeroDamaged(state, 1 - ownerIdx, taken);
  } else {
    if (taken > 0) onUnitDamaged(state, { ownerIdx: 1 - ownerIdx, card: target, dmg: taken });
    if (target.hp <= 0) {
      enemy.removeFromField(target);
      state.log?.add(`✗ ${target.name_ru} [${enemy.name}] погибает (от Парамедика)`);
      dispatchUnitDied(state, {
        ownerIdx: 1 - ownerIdx, card: target,
        killer: paramedik, killerIdx: ownerIdx, killerWasCounter: false
      });
    }
  }
}

function paramedikLine1Heal(state, ownerIdx, paramedik) {
  const me = state.players[ownerIdx];
  if (!me) return;
  // Кандидаты: живые свои юниты + Герой (если жив).
  const candidates = me.unitsOnField().filter(u => u.isAlive());
  if (me.hero && me.hero.hp > 0) candidates.push(me.hero);
  if (candidates.length === 0) return;
  const target = candidates[state.rng.int(candidates.length)];
  const cur = target.current?.hp ?? target.hp;
  const max = target.base?.hp ?? target.maxHp ?? cur;
  if (cur >= max) {
    // На полном ХП → overshield 0/1/0 до конца хода (expiresAtTurn = currentTurn+1).
    applyTemporaryBuff(
      state, target,
      { atk: 0, armor: 1, hp: 0 },
      state.currentTurn + 1,
      `${CARD_ID}_overshield`,
      `${LABEL} (overshield)`
    );
    const targetName = target.type === 'hero' ? shortHeroName(target) : target.name_ru;
    state.log?.add(
      `🛡 ${targetName} [${me.name}]: +1 броня (overshield от ${LABEL})`
    );
    return;
  }
  // Обычный хил.
  healUnit(state, target, 1, paramedik);
}
